<!-- src/views/AttendanceNotice.vue -->
<template>
  <div class="attendance-notice">
    <div class="notice-container">
      <div class="notice-content">
        <div class="english-version">
          <div class="chinese-version">
            <p>家长您好，</p>
            <p>
              我们注意到今早考勤标记孩子未到校。目前我们还未收到您的请假信息，我们想先跟您确认一下孩子的情况，是否是请假或者今早晚到。
            </p>
            <p>
              根据最新的请假政策，如果因故需要晚到或者请假，请扫描或长按下方二维码在启明星在线家长服务号上提交。由考勤老师统一管理记录，感谢您的支持与理解！
            </p>
          </div>
          <p>
            Dear Parents,
          </p>
          <p>
            We've noticed that the attendance of your child this morning was marked Absent by their teacher. However,
            we didn't receive a leave request for today. We would like to send this email first to confirm with you the
            attendance of your child today, whether she/he was late or will be absent today.
          </p>
          <p>
            According to our leave policy, please scan or long-press the QR code below to submit the leave request via
            DSOnline. The attendance teacher will manage and update the attendance. Thank you for your support and
            understanding!
          </p>
        </div>
      </div>

      <!-- 二维码区域 -->
      <div class="qr-code-section">
        <div class="qr-code-container">
          <img
              src="@/assets/SecondaryAttendance.png"
              alt="中学生请假"
              class="qr-code-image"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AttendanceNotice',
  mounted() {
    document.title = this.$t("router.attendanceNotice");
  }
}
</script>

<style scoped>
.attendance-notice {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}

.notice-container {
  max-width: 800px;
  margin: 0 auto;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 30px;
}

.title {
  text-align: center;
  color: #333;
  margin-bottom: 30px;
  font-size: 28px;
}

.notice-content {
  margin-bottom: 30px;
}

.english-version, .chinese-version {
  margin-bottom: 30px;
  line-height: 1.6;
}

.english-version h2, .chinese-version h2 {
  color: #409eff;
  border-bottom: 2px solid #409eff;
  padding-bottom: 10px;
  margin-bottom: 15px;
}

.chinese-version p {
  text-indent: 2em;
}

/* 排除第一个p元素的缩进 */
.chinese-version p:first-child {
  text-indent: 0;
}

.leave-instructions {
  background-color: #e8f4ff;
  border-left: 4px solid #409eff;
  padding: 20px;
  border-radius: 4px;
}

.leave-instructions h2 {
  color: #409eff;
  margin-top: 0;
}

.leave-instructions ol {
  padding-left: 20px;
}

.leave-instructions li {
  margin-bottom: 10px;
  line-height: 1.5;
}

/* 二维码样式 */
.qr-code-section {
  text-align: center;
  padding: 30px 0 20px;
  border-top: 1px solid #eee;
  margin-top: 20px;
}

.qr-code-section h3 {
  color: #333;
  margin-bottom: 20px;
  font-size: 18px;
}

.qr-code-container {
  display: inline-block;
}

.qr-code-image {
  width: 280px;
  height: 300px;
  display: block;
  margin: 0 auto 10px;
}
</style>
